import { render, staticRenderFns } from "./modalpopup2fa.vue?vue&type=template&id=2140168a&"
import script from "./modalpopup2fa.vue?vue&type=script&lang=js&"
export * from "./modalpopup2fa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2140168a')) {
      api.createRecord('2140168a', component.options)
    } else {
      api.reload('2140168a', component.options)
    }
    module.hot.accept("./modalpopup2fa.vue?vue&type=template&id=2140168a&", function () {
      api.rerender('2140168a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/components/modalpopup2fa.vue"
export default component.exports